export default "__VITE_ASSET__eba94afe__"